import { render, staticRenderFns } from "./productoptions.vue?vue&type=template&id=2277efb1&"
import script from "./productoptions.vue?vue&type=script&lang=js&"
export * from "./productoptions.vue?vue&type=script&lang=js&"
import style0 from "./productoptions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports